var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{ref:"form",attrs:{"action":_vm.url,"method":"post"}},[_vm._l((_vm.data),function(value,name){return _c('input',{attrs:{"type":"hidden","name":name},domProps:{"value":value}})}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }